"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StatusFormatType = exports.StatusFormatStatus = exports.StatusCommon = void 0;
exports.getStatusAntdCode = getStatusAntdCode;
exports.getStatusFormatColor = getStatusFormatColor;
exports.getStatusFormatIcon = getStatusFormatIcon;
exports.getStatusFormatIconCircled = getStatusFormatIconCircled;
exports.getStatusFormatIconFilled = getStatusFormatIconFilled;

require("core-js/modules/es.object.assign");

require("antd/lib/tooltip/style");

var _tooltip = _interopRequireDefault(require("antd/lib/tooltip"));

require("antd/lib/tag/style");

var _tag = _interopRequireDefault(require("antd/lib/tag"));

require("antd/lib/badge/style");

var _badge = _interopRequireDefault(require("antd/lib/badge"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _react = _interopRequireDefault(require("react"));

require("./StatusFormat.less");

var _TextFormat = _interopRequireDefault(require("./TextFormat"));

var _icons = require("@ant-design/icons");

var _classnames = _interopRequireDefault(require("classnames"));

var _default = StatusFormat;
exports.default = _default;
var StatusCommon;
exports.StatusCommon = StatusCommon;

(function (StatusCommon) {
  StatusCommon["MAINTENANCE"] = "maintenance";
})(StatusCommon || (exports.StatusCommon = StatusCommon = {}));

var StatusFormatStatus;
exports.StatusFormatStatus = StatusFormatStatus;

(function (StatusFormatStatus) {
  StatusFormatStatus["success"] = "success";
  StatusFormatStatus["warning"] = "warning";
  StatusFormatStatus["error"] = "error";
  StatusFormatStatus["info"] = "info";
  StatusFormatStatus["default"] = "default";
  StatusFormatStatus["unknown"] = "unknown";
  StatusFormatStatus["loading"] = "loading";
})(StatusFormatStatus || (exports.StatusFormatStatus = StatusFormatStatus = {}));

var StatusFormatType;
exports.StatusFormatType = StatusFormatType;

(function (StatusFormatType) {
  StatusFormatType["icon"] = "icon";
  StatusFormatType["iconCircled"] = "iconCircled";
  StatusFormatType["iconFilled"] = "iconFilled";
  StatusFormatType["dot"] = "dot";
  StatusFormatType["tag"] = "tag";
})(StatusFormatType || (exports.StatusFormatType = StatusFormatType = {}));

function getStatusFormatColor(status) {
  switch (status) {
    case 'success':
      return '#52c41a';

    case 'error':
      return '#ff4d4f';

    case 'warning':
      return '#faad14';

    case 'info':
    case 'loading':
      return '#1890ff';

    case 'unknown':
      return '#dbdbdb';

    default:
      return '';
  }
}

function getStatusAntdCode(status) {
  switch (status) {
    case StatusFormatStatus.unknown:
      return 'default';

    case StatusFormatStatus.loading:
    case StatusFormatStatus.info:
      return 'processing';

    default:
      return status;
  }
}

function getStatusFormatIcon(status, iconProps) {
  switch (status) {
    case 'success':
      return /*#__PURE__*/_react.default.createElement(_icons.CheckOutlined, Object.assign({
        className: "StatusFormat_icon-success"
      }, iconProps));

    case 'error':
      return /*#__PURE__*/_react.default.createElement(_icons.CloseOutlined, Object.assign({
        className: "StatusFormat_icon-error"
      }, iconProps));

    case 'warning':
      return /*#__PURE__*/_react.default.createElement(_icons.ExclamationOutlined, Object.assign({
        className: "StatusFormat_icon-warning"
      }, iconProps));

    case 'info':
      return /*#__PURE__*/_react.default.createElement(_icons.InfoOutlined, Object.assign({
        className: "StatusFormat_icon-info"
      }, iconProps));

    case 'loading':
      return /*#__PURE__*/_react.default.createElement(_icons.LoadingOutlined, Object.assign({
        className: "StatusFormat_icon-loading"
      }, iconProps));

    case 'default':
    default:
      return /*#__PURE__*/_react.default.createElement(_icons.QuestionOutlined, Object.assign({
        className: "StatusFormat_icon-unknown"
      }, iconProps));
  }
}

function getStatusFormatIconFilled(status) {
  var iconProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (status) {
    case 'success':
      return /*#__PURE__*/_react.default.createElement(_icons.CheckCircleFilled, Object.assign({
        className: "StatusFormat_icon-success"
      }, iconProps));

    case 'error':
      return /*#__PURE__*/_react.default.createElement(_icons.CloseCircleFilled, Object.assign({
        className: "StatusFormat_icon-error"
      }, iconProps));

    case 'warning':
      return /*#__PURE__*/_react.default.createElement(_icons.ExclamationCircleFilled, Object.assign({
        className: "StatusFormat_icon-warning"
      }, iconProps));

    case 'info':
      return /*#__PURE__*/_react.default.createElement(_icons.InfoCircleFilled, Object.assign({
        className: "StatusFormat_icon-info"
      }, iconProps));

    case 'loading':
      return /*#__PURE__*/_react.default.createElement(_icons.LoadingOutlined, Object.assign({
        className: "StatusFormat_icon-loading"
      }, iconProps));

    case 'default':
    default:
      return /*#__PURE__*/_react.default.createElement(_icons.QuestionCircleFilled, Object.assign({
        className: "StatusFormat_icon-unknown"
      }, iconProps));
  }
}

function getStatusFormatIconCircled(status) {
  var iconProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (status) {
    case 'success':
      return /*#__PURE__*/_react.default.createElement(_icons.CheckCircleOutlined, Object.assign({
        className: "StatusFormat_icon-success"
      }, iconProps));

    case 'error':
      return /*#__PURE__*/_react.default.createElement(_icons.CloseCircleOutlined, Object.assign({
        className: "StatusFormat_icon-error"
      }, iconProps));

    case 'warning':
      return /*#__PURE__*/_react.default.createElement(_icons.ExclamationCircleOutlined, Object.assign({
        className: "StatusFormat_icon-warning"
      }, iconProps));

    case 'info':
      return /*#__PURE__*/_react.default.createElement(_icons.InfoCircleOutlined, Object.assign({
        className: "StatusFormat_icon-info"
      }, iconProps));

    case 'loading':
      return /*#__PURE__*/_react.default.createElement(_icons.LoadingOutlined, Object.assign({
        className: "StatusFormat_icon-loading"
      }, iconProps));

    case 'default':
    default:
      return /*#__PURE__*/_react.default.createElement(_icons.QuestionCircleOutlined, Object.assign({
        className: "StatusFormat_icon-unknown"
      }, iconProps));
  }
}

function StatusFormat(_ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      _ref$colorText = _ref.colorText,
      colorText = _ref$colorText === void 0 ? true : _ref$colorText,
      icon = _ref.icon,
      loading = _ref.loading,
      _ref$nowrap = _ref.nowrap,
      nowrap = _ref$nowrap === void 0 ? false : _ref$nowrap,
      _ref$showTooltip = _ref.showTooltip,
      showTooltip = _ref$showTooltip === void 0 ? true : _ref$showTooltip,
      _ref$status = _ref.status,
      status = _ref$status === void 0 ? StatusFormatStatus.default : _ref$status,
      style = _ref.style,
      text = _ref.text,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? StatusFormatType.dot : _ref$type;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('StatusFormat', className)
  }, type === StatusFormatType.dot ? /*#__PURE__*/_react.default.createElement(_badge.default, {
    status: getStatusAntdCode(status),
    text: text || children,
    className: (0, _classnames.default)('StatusFormat_badge', (_classNames = {}, (0, _defineProperty2.default)(_classNames, "StatusFormat_badge-".concat(status), colorText), (0, _defineProperty2.default)(_classNames, "StatusFormat_badge-nowrap", nowrap), _classNames)),
    color: getStatusFormatColor(status)
  }) : type === StatusFormatType.tag ? /*#__PURE__*/_react.default.createElement(_tag.default, {
    icon: icon !== undefined ? icon : getStatusFormatIcon(status),
    color: getStatusAntdCode(status)
  }, text || children) : /*#__PURE__*/_react.default.createElement(_tooltip.default, Object.assign({
    title: text || children
  }, showTooltip ? {} : {
    visible: false
  }), /*#__PURE__*/_react.default.createElement(_TextFormat.default, {
    type: status
  }, loading ? /*#__PURE__*/_react.default.createElement(_icons.LoadingOutlined, {
    spin: true
  }) : icon ? icon : type === StatusFormatType.iconFilled ? getStatusFormatIconFilled(status, {}) : type === StatusFormatType.iconCircled ? getStatusFormatIconCircled(status, {}) : getStatusFormatIcon(status, {}))));
}